(function (sb) {
	sb.Html = {};

	function saveHtml(htmlContent, layoutElementId, guid, editedElement, title) {
		// Parses out all links in the html and removes preview=true if it exists in the url
		// and adds the zIndex "fix" (wmode=opaque) for videoclips.
		var arrURLs = HTMLHelpers.parseURLsInHtml(htmlContent);
		if (arrURLs.length > 0) {
			for (var i in arrURLs) 
				if(arrURLs.hasOwnProperty(i)) { 

				var url = arrURLs[i].toString();
				url = url.replace(/\?preview=true/gi, "");
				url = url.replace(/&preview=true/gi, "");
				var lowerURL = url.toLowerCase();
				if (lowerURL.indexOf('?wmode=opaque') < 0 && lowerURL.indexOf('&amp;wmode=opaque') < 0 && lowerURL.indexOf('&wmode=opaque') < 0 && !(lowerURL.indexOf('#') > 0) && lowerURL.indexOf('.aspx?') < 0) {
					url = url.substr(0, url.length - 1);
					url += (((url.indexOf('?') > 0) ? '&' : '?') + 'wmode=opaque"');
				}
				htmlContent = htmlContent.replace(arrURLs[i], url);
			}
			if (htmlContent.toLowerCase().indexOf('<param name="wmode" value="opaque">') < 0) {
				htmlContent = htmlContent.replace(/<embed/gi, '<param name="wmode" value="opaque"><embed wmode="opaque"');
			}
		}

		// encode question marks because of jquery issue with posting data with question marks using ajax post method
		htmlContent = htmlContent.split('??').join('&#63;&#63;');

		// fix for IE issue
		// data-user-events attribute ends up with characters " instead of &quote;
		var dataUserEventsPattern = /data-user-events=["']\[(.*?)\]["']/;
		if (dataUserEventsPattern.test(htmlContent)) {
			var quotedDataEvents = htmlContent.match(dataUserEventsPattern)[1].split('"').join('&quot;');
			htmlContent = htmlContent.replace(dataUserEventsPattern, 'data-user-events="[' + quotedDataEvents + ']"');
		}

		if (window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART) {
			htmlSaved(editedElement, htmlContent, title, layoutElementId);
			ChartCreatorUI.enableDisableExportButton();
			ChartCreatorUI.enableDisableShareButton();
			Storyboard.LayoutDesigner.setState(true);
		} else {
			var data = { html: { Value: htmlContent, LayoutElementId: layoutElementId, Guid: guid } };
			Helpers.performJSonCall(window.IsFormReport ? "FormReport.aspx/SaveHTML" : "RHViewStoryboard.aspx/SaveHTML", data,
				function () { htmlSaved(editedElement, htmlContent, title, layoutElementId); }, htmlSaveFailed, true);
		}
	}

	function htmlSaved(editedElement, htmlContent, title, layoutElementId) {
		var titleText = (title.length > 0) ? ' - ' + title + ': ' : ': ';
		editedElement.content = htmlContent;
		if (!(window.ContentType > 0)) {
			Storyboard.LayoutControls.showMessage("Html box " + (layoutElementId || '') + titleText + "Content saved");
			setTimeout("$('#MessagePopup').fadeOut('fast')", 2000);
		}

		if (!Storyboard.LayoutDesigner.isUnsaved && layoutElementId > 0)
			Storyboard.LayoutDesigner.refreshSlideToplineCompatibility();
	}

	function htmlSaveFailed(errorMessage) {
		Storyboard.LayoutControls.showMessage(errorMessage);
		setTimeout("$('#MessagePopup').fadeOut('fast')", 2000);
	}

	sb.Html.saveHtml = saveHtml;
})(window.Storyboard = (window.Storyboard || {}));